<script>
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { dateTransform } from "@/utils/utils.js";
import editor from './editor';

export default {
  listTableTopOffset: 268,
  props: ['pageNum'],
  data() {
    return {
      tableColumns: [
        {
          label: "安装包名称",
          prop: "file_real_name",
          width: 250
        },
        {
          label: "下载地址",
          prop: "file_down_path",
          width: 220
        },
        {
          label: "apk版本",
          prop: "name",
          width: 100
        },
        {
          label: "创建人",
          prop: "create_by",
        },
        {
          label: "版本说明",
          prop: "remark",
          width: 120
        },
        {
          label: "白名单状态",
          prop: "white_list_status",
          width: 90
        },
        {
          label: "白名单",
          prop: "white_list"
        },
        {
          label: "OTA 升级",
          prop: "status",
          width: 80
        },
        {
          label: "版本库展示",
          prop: "catalog_show",
          width: 90
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: 130
        },
        {
          label: "操作",
          prop: "operations",
          width: "360"
        },
      ],
      formatMap: {
        white_list_status: {
          'true': '启用',
          'false': '停用'
        },
        status: {
          'true': '是',
          'false': '否'
        },
        catalog_show: {
          'true': '是',
          'false': '否'
        }
      }
    };
  },
  computed: {
    ...mapGetters(["apkList", "apkListTotal"]),
    formatTime() {
      return (val) => {
        return dateTransform(val) || "";
      };
    },
  },
  methods: {
    ...mapActions(['deleteApkData']),
    handleSelectionChange(val) {
      this.$emit("selectChange", val);
    },
    getTableData(params) {
      this.$emit("getDatas", params);
    },
    getFormatName(key, val) {
      return this.$tt((this.formatMap[key] && this.formatMap[key][val]) || val || '');
    },
    handleEdit(row) {
      this.$router.push('/clientManage/apk/edit?id=' + row.id);
    },
    editWhiteList(row) {
      this.$refs.editorRef.show({
        id: row.id,
        white_list: row.white_list
      });
    },
    copyDownPath(url) {
      if (!url) {
        this.$message.warning(this.$tt("没有下载地址"));
        return;
      }
      const done = () => this.$message.success(this.$tt("已复制下载地址"));
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => this.copyByTextarea(url, done));
        return;
      }
      this.copyByTextarea(url, done);
    },
    copyByTextarea(url, done) {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        this.$message.error(this.$tt("复制失败"));
      }
      document.body.removeChild(ta);
    },
    confirmDelete(row) {
      this.$confirm(
        this.$tt("删除后，安装包记录及服务器上的源文件将一并删除且无法恢复，是否继续？"),
        this.$tt("删除确认"),
        { type: "warning", confirmButtonText: this.$tt("确定"), cancelButtonText: this.$tt("取消") }
      )
        .then(() => this.deleteData(row))
        .catch(() => {});
    },
    async deleteData(row) {
      try {
        this.$changeLoadingState(true);
        await this.deleteApkData({ids: [row.id]});
        this.$changeLoadingState(false);
        this.getTableData();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    editorConfirm() {
      this.$emit("getDatas");
    }
  },
  components: {
    Pagination,
    editor
  },
};
</script>
<template>
  <div>
    <el-table
      :data="apkList"
      style="width: 100%"
      class="projectsTable"
      border
      :max-height="listTableMaxHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        v-for="c in tableColumns"
        :key="c.prop"
        :label="$tt(c.label)"
        :width="$listColWidth(c)"
        :min-width="$listColMinWidth(c)"
        :prop="$listColProp(c)"
        :sortable="$listSortable(c)"
        :class-name="$listColClass(c)"
        :label-class-name="$listColClass(c)"
        :fixed="$listColFixed(c)"
        :show-overflow-tooltip="$listOverflow(c)"
      >
        <template slot-scope="scope">
          <div v-if="c.prop.indexOf('time') > -1">
            {{ formatTime(scope.row[c.prop]) }}
          </div>
          <div v-else-if="!!formatMap[c.prop]">
            <span :style="{color: scope.row[c.prop] === 'true' ? '#67C23A' : '#F56C6C'}">{{ getFormatName(c.prop, scope.row[c.prop]) }}</span>
          </div>
          <div v-else-if="c.prop === 'file_down_path'" class="table-ellipsis-text">
            <a target="_blank" :href="scope.row[c.prop]" :title="scope.row[c.prop]">{{scope.row[c.prop]}}</a>
          </div>
          <div class="table-ops" v-else-if="c.prop == 'operations'">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            >
              {{ $tt("修改") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-document-copy"
              :disabled="!scope.row.file_down_path"
              @click="copyDownPath(scope.row.file_down_path)"
            >
              {{ $tt("复制下载地址") }}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-setting"
              :disabled="scope.row.white_list_status !== 'true'"
              @click="editWhiteList(scope.row)"
            >
              {{ $tt("白名单设置") }}
            </el-button>
            <el-button
              type="text"
              size="mini"
              class="delete-text-btn"
              icon="el-icon-delete"
              @click="confirmDelete(scope.row)"
            >
              {{ $tt("删除") }}
            </el-button>
          </div>
          <span v-else class="table-ellipsis-text" :title="scope.row[c.prop]">{{ scope.row[c.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-if="apkListTotal > 0"
      :handleSizeChange="
        (v) => {
          this.getTableData({ page_size: v });
        }
      "
      :handleCurrentPageChange="
        (v) => {
          this.getTableData({ page_num: v });
        }
      "
      :total="apkListTotal"
      :pageNum="pageNum"
    />
    <editor ref="editorRef" @confirm="editorConfirm"></editor>
  </div>
</template>